import { Menu, MenuButton, MenuList, MenuItem, IconButton } from '@chakra-ui/react';
import { FaGlobe } from 'react-icons/fa';
import { useTranslationsQuery, useUpdateUserMutation } from '../app/api';
import { useDispatch, useSelector } from 'react-redux';
import { set_lang, set_translations } from '../app/ui_state';
import { path } from 'ramda';

const LanguageSwitcher = ({ currentLang }) => {
  const [updateUser] = useUpdateUserMutation();
  const dispatch = useDispatch();
  const user = useSelector(path(["ui","session","user"]));
  const {data:translations} = useTranslationsQuery();

  const handleSubmit = async (lang) => {
    dispatch(set_lang(lang));
    dispatch(set_translations(translations[lang]));
    if (user) {
      if (currentLang !== lang) {
        console.log(lang,user);
        updateUser({
          id: user.id,
          lang,
        });
      }
    } 
    localStorage.setItem("lang", lang);
  }

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'et', label: 'Eesti' },
  ];

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={<FaGlobe />}
        colorScheme='teal'
        variant="ghost"
        aria-label="Change language"
      />
      <MenuList>
        {languages.map(({ code, label }) => (
          <MenuItem
            key={code}
            onClick={() => handleSubmit(code)}
            fontWeight={currentLang === code ? 'bold' : 'normal'}
          >
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSwitcher;